import customAxios from '../interceptors';

const updateTenant = (tenantID: string, params: any) => {
  return customAxios.put(`${process.env.REACT_APP_API_URL}/tenants/${tenantID}`, {
    ...params
  });
}

export default updateTenant;
